import { render, staticRenderFns } from "./P2.vue?vue&type=template&id=b70a0a28&"
import script from "./P2.vue?vue&type=script&lang=js&"
export * from "./P2.vue?vue&type=script&lang=js&"
import style0 from "./P2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports